/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
import { dismissLoader, presentLoader } from "../../Services/loader";
import * as _ from "lodash";
import cssClasses from "./Home.module.css";
import { Box, Button, Card, CardContent, CircularProgress, Step, StepConnector, StepLabel, Stepper, stepConnectorClasses, styled, useMediaQuery } from "@mui/material";

import UserIcon from "../../Assets/Images/Common/ProfileUser-01.svg";
import MailIcon from "../../Assets/Images/Common/ProfileMail-01.svg";
import PhoneCallIcon from "../../Assets/Images/Common/ProfilePhone-01.svg";
import { Check } from "@mui/icons-material";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import ArrowRightIcon from "../../Assets/Images/Common/arrow-right.svg";
import Token from "./Token";
import InfoIcon from "../../Assets/Images/Common/info-circle.svg";
import Allotment from "./Allotment";
import BalanceSDR from "./BalanceSDR";
import { supabase } from "../../supabaseClient";
import { getLeadTokens, getPreselectTokenData, getPriorityPassTokens, getTokenServerTime } from "../../Services/Tokens";
import { errorTost } from "../../Services/Toast";

import { getLeadAllotmentsForDashboard, getPreselectConfirmationsConfig, sdrPaymentMode } from "../../Services/Allotment";
import { Tooltip as ReactTooltip } from "react-tooltip";
import BalanceOCRGST from "./BalanceOCRGST";
import Agreement from "./Agreement";
import EmptyDashboardIcon from "../../Assets/Images/EmptyDataIcons/EmptyDashboard.svg";
import EmptyListIcon from "../../Assets/Images/EmptyDataIcons/Artwork.svg";
import { useLocation } from "react-router-dom";
import DropDown from "../../Subcomponents/DropDown";
import { StepperENUM } from "../../Assets/Common/CommonENUM";

const useStyles = makeStyles((theme) => ({
	label: {
		"& .stepperTitle": {
			fontWeight: "500",
			fontSize: "1.6rem",
			lineHeight: "2rem",
			fontFamily: "'Inter-Medium'",
		},
		"& .text": {
			fontSize: "1.4rem",
			lineHeight: "2rem",
		},
		"& .Mui-active": {
			color: "#1570EF !important",
		},
		"& .Mui-completed": {
			color: "#344054 !important",
		},
		"& .MuiStepLabel-label": {
			fontFamily: "'Inter-Regular'",
		},
		"& .MuiStepLabel-alternativeLabel": {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
	},
}));

const Home = () => {
	const dispatch = useDispatch();
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	const activeMenu = useSelector((state) => state.ActiveMenu.activeMenu);
	const [serverTime, setServerTime] = useState("");
	const allTokens = useRef([]);
	const allAllotments = useRef([]);
	const [allData, setAllData] = useState([]);
	const tokenFlag = useRef(false);
	const allotmentFlag = useRef(false);
	const [SdrPaymentMode, setSdrPaymentMode] = useState(null);
	const [recordUpdated, setRecordUpdated] = useState({ type: "", data: {} });
	const [ppTokenIds, setPPTokenIds] = useState([]);
	const showSalesManagerCard = useMediaQuery("(max-width:820px)");
	const path = useLocation();
	const classes = useStyles();
	const [filterAllotments, setFilterAllotments] = useState(allData || []);
	const [sort, setSort] = useState("All");
	const [updatedRecord, setUpdatedRecord] = useState([]);
	const [slotBookMode, setSlotBooktMode] = useState(false);

	const menuItem = [
		"All",
		"Partial Payment Done",
		"Payment Complete",
		"On hold",
		"Payment Pending",
		"Change requested",
		"Cancellation Requested",
		"Cancellation Pending",
		"Cancelled",
		"Refund Initiated",
		"Refund Requested",
		"Refund Processed",
		"Refund Rejected",
		"Released",
	];

	const QontoConnector = styled(StepConnector)(({ theme }) => ({
		[`&.${stepConnectorClasses.alternativeLabel}`]: {
			top: 10,
			left: "calc(-50% + 1.6rem)",
			right: "calc(50% + 1.6rem)",
		},
		[`&.${stepConnectorClasses.active}`]: {
			[`& .${stepConnectorClasses.line}`]: {
				borderColor: "#1570EF",
			},
		},
		[`&.${stepConnectorClasses.completed}`]: {
			[`& .${stepConnectorClasses.line}`]: {
				borderColor: "#1570EF",
			},
		},
		[`& .${stepConnectorClasses.line}`]: {
			borderColor: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
			borderTopWidth: 3,
			borderRadius: 1,
		},
	}));

	const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
		color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
		display: "flex",
		height: 22,
		alignItems: "center",
		...(ownerState.active && {
			color: "#1570EF",
			boxShadow: "",
			backgroundColor: "#F9F5FF !important",
			borderRadius: "50% !important",
			fontSize: "1.8rem",
			padding: "0.1rem 0.8rem !important",
		}),
		"& .QontoStepIcon-completedIcon": {
			color: "#1570EF",
			zIndex: "1",
			backgroundColor: "#F9F5FF !important",
			borderRadius: "50% !important",
			fontSize: "1.8rem",
			padding: "0.5rem !important",
			width: "2.5rem !important",
			height: "2.5rem !important",
		},
		"& .QontoStepIcon-circle": {
			width: 8,
			height: 8,
			borderRadius: "50%",
			backgroundColor: "currentColor",
		},
	}));

	function QontoStepIcon(props) {
		const { active, completed, className } = props;
		return (
			<QontoStepIconRoot ownerState={{ active }} className={className}>
				{completed ? <Check className="QontoStepIcon-completedIcon" /> : <div className="QontoStepIcon-circle" />}
			</QontoStepIconRoot>
		);
	}

	QontoStepIcon.prototype = {
		/**
		 * Whether this step is active.
		 * @default false
		 */
		active: PropTypes.bool,
		className: PropTypes.string,
		/**
		 * Mark the step as completed. Is passed to child components.
		 * @default false
		 */
		completed: PropTypes.bool,
	};

	useEffect(() => {
		presentLoader();
		setAllData([]);
		path.pathname === "/Home/Allotments" ? dispatch(actions.activeMenu("allotments")) : dispatch(actions.activeMenu("dashboard"));
		// setTabChange(path.pathname);
	}, [activeMenu]);
	useEffect(() => {
		presentLoader();
		setAllData([]);
	}, [path.pathname]);
	useEffect(() => {
		if (sort) {
			handleChange(sort);
		} else {
			setFilterAllotments(allData);
		}
	}, [allData]);
	useEffect(() => {
		setFilterAllotments(allData);
		setSort("All");
	}, [activeMenu]);
	const getServerTime = async () => {
		getTokenServerTime()
			.then((res) => {
				setServerTime(res?.data?.currentTime);
			})
			.catch((error) => {
				console.log("err in serverTime api call", error);
			});
	};

	useEffect(() => {
		setTimeout(() => {
			getServerTime();
		}, 1000);
	}, [activeMenu]);

	const fetchData = async () => {
		if (activeMenu === "allotments") {
			await getAllotments();
		} else {
			await getTokens()
				.then(async () => {
					await getAllotments();
				})
				.catch(async () => {
					await getAllotments();
				});
		}
	};
	useEffect(() => {
		fetchData();
		 // ✅ Check if user came from ConfirmUnitModal
  const fromAllotmentConfirm = sessionStorage.getItem("fromAllotmentConfirm");

  if (fromAllotmentConfirm) {
    presentLoader(); // show loader immediately
  }

  fetchData().finally(() => {
    // ✅ Once data is fetched, hide loader and remove flag
    if (fromAllotmentConfirm) {
      dismissLoader();
      sessionStorage.removeItem("fromAllotmentConfirm");
    }
  });

		let insertUnitListener = supabase
			.from(`EventTokenLeadRelations`)
			.on("INSERT", (handleRecordUpdated) => {
				if (handleRecordUpdated.new.leadId === loggedInUser.leadId) {
					getTokens();
					// setRecordUpdated({ type: "token", data: handleRecordUpdated });
				}
			})
			.on("DELETE", (handleRecordUpdated) => {
				if (handleRecordUpdated.new.leadId === loggedInUser.leadId) {
					getTokens();
					// setRecordUpdated({ type: "token", data: handleRecordUpdated });
				}
			})
			.subscribe((status) => { });
		let updateUnitListener = supabase
			.from(`EventTokenLeadRelations:leadId=eq.${loggedInUser.leadId}`)
			.on("UPDATE", (handleRecordUpdated) => {
				// setHandleRecordUpdated({ type: "token", data: handleRecordUpdated });
				const newDataIndex = allTokens.current.findIndex((e) => e.paymentId === handleRecordUpdated.new.paymentId);
				if (newDataIndex !== -1) {
					tokenFlag.current = false;
					//Cheking data is found or not
					let newData = [...allTokens.current];
					newData[newDataIndex]["payId"] = handleRecordUpdated.new.payId;
					newData[newDataIndex]["paidAmount"] = handleRecordUpdated.new.paidAmount;
					newData[newDataIndex]["status"] = handleRecordUpdated.new.status;
					newData[newDataIndex]["last_updated_at"] = handleRecordUpdated.new.last_updated_at;
					allTokens.current = newData;
					tokenFlag.current = true;
					setRecordUpdated({ type: "token", data: handleRecordUpdated }); // set State to trigger the useffect for stepper functionality
				} else {
					getTokens();
				}
			})
			.subscribe((status) => { });

		let insertAllotmentListener = supabase
			.from(`AllotmentPayment`)
			.on("INSERT", (handleRecordUpdated) => {
				if (handleRecordUpdated.new.leadId === loggedInUser.leadId) {
					getAllotments();
					// setRecordUpdated({ type: "allotment", data: handleRecordUpdated });
				}
			})
			.subscribe((status) => { });
		let updateAllotmentListener = supabase
			.from(`AllotmentPayment:leadId=eq.${loggedInUser.leadId}`)
			.on("UPDATE", (handleRecordUpdated) => {
				// !For preselect token check full amount paid
				const preselectToken = allTokens.current.find((token) => token.paymentId === handleRecordUpdated.new.paymentId);
				if (handleRecordUpdated.new.pricingType === "preselect") {
					const preselectTokenIndex = allTokens.current.findIndex((token) => token.paymentId === handleRecordUpdated.new.paymentId);
					if (preselectTokenIndex !== -1) {
						tokenFlag.current = false;
						let newData = [...allTokens.current];
						newData[preselectTokenIndex]["kycFormFilled"] = handleRecordUpdated.new.kycFormFilled;
						allTokens.current = newData;
						tokenFlag.current = true;
						setRecordUpdated({ type: "token", data: handleRecordUpdated });
					}
				}
				const newDataIndex = allAllotments.current.findIndex((e) => e.allotmentPaymentId === handleRecordUpdated.new.allotmentPaymentId);
				if (newDataIndex !== -1) {
					allotmentFlag.current = false;
					//Cheking data is found or not+
					let newData = [...allAllotments.current];
					newData[newDataIndex]["paidAmount"] = handleRecordUpdated.new.paidAmount;
					newData[newDataIndex]["paidAmt"] = handleRecordUpdated.new.paidAmt;
					newData[newDataIndex]["status"] = handleRecordUpdated.new.status;
					newData[newDataIndex]["last_updated_at"] = handleRecordUpdated.new.last_updated_at;
					//! to do for kyc form filled
					newData[newDataIndex]["kycFormFilled"] = handleRecordUpdated.new.kycFormFilled;
					newData[newDataIndex]["isAgreementFormFilled"] = handleRecordUpdated.new.isAgreementFormFilled;
					newData[newDataIndex]["preselectConfirmation"] = handleRecordUpdated.new.preselectConfirmation;
					newData[newDataIndex]["unitCost"] = handleRecordUpdated.new.unitCost;
					newData[newDataIndex]["bookingAmt"] = handleRecordUpdated.new.bookingAmt;
					newData[newDataIndex]["isBucketingApplied"] = handleRecordUpdated.new.isBucketingApplied;
					newData[newDataIndex]["bookingFormId"] = newData[newDataIndex]["bookingFormId"]
						? newData[newDataIndex]["bookingFormId"]
						: handleRecordUpdated.new.bookingFormId;
					newData[newDataIndex].totalUnitPrice = handleRecordUpdated.new.unitCost?.total;
					if (handleRecordUpdated.new.status === "Payment Complete" || handleRecordUpdated.new.status === "Partial Payment Done") {
						if (newData[newDataIndex]["CancelUnitRequests"].length > 0) {
							let Cancelled_Far_vision = newData[newDataIndex]["CancelUnitRequests"].find((ele) => {
								return ele.cancelledInFarvision === true;
							});
							if (!Cancelled_Far_vision) {
								newData[newDataIndex]["menuOpt"] = ["View Details", "Cancel Unit"];
							}
						} else {
							newData[newDataIndex]["menuOpt"] = ["View Details", "Cancel Unit"];
						}
					} else if (handleRecordUpdated.new.status === "Cancellation Pending") {
						newData[newDataIndex]["menuOpt"] = ["View Details"];
					} else {
						newData[newDataIndex]["menuOpt"] = ["View Details"];
					}
					// newData[newDataIndex]["totalUnitPrice"] = handleRecordUpdated.new.unitId && handleRecordUpdated.new.unitId?.totalCost;
					allAllotments.current = newData;
					allotmentFlag.current = true;
					setRecordUpdated({ type: "allotment", data: handleRecordUpdated }); // set State to trigger the useffect for stepper functionality
				} else {
					getAllotments();
					setRecordUpdated({ type: "allotment", data: handleRecordUpdated });
				}
			})
			.subscribe((status) => { });
		let updateEventListener = supabase
			.from(`PreselectConfirmationConfig`)
			.on("UPDATE", (handleRecordUpdated) => {
				if (handleRecordUpdated) {
					let data = [];
					const newData = allAllotments.current.map((allotment) => {
						if (
							handleRecordUpdated?.new?.launchId === allotment?.launchId &&
							handleRecordUpdated.new.eventId === allotment?.paymentId?.eventId &&
							handleRecordUpdated.new.eventTokenId === allotment?.paymentId?.eventTokenId?.eventTokenId
						) {
							data = [...data, handleRecordUpdated];
							allotment.paymentId.eventTokenId.eventId.preselectConfirmationConfig =
								handleRecordUpdated.new.preselectConfirmationConfig;
							return allotment;
						} else {
							return allotment;
						}
					});
					allAllotments.current = newData;
					if (data.length > 0) {
						setUpdatedRecord(data);
					}
				}
			})
			.subscribe((status) => { });
		let updatedSetting = supabase
			.from(`Settings`)
			.on("UPDATE", (handleRecordUpdated) => {
				setSlotBooktMode(handleRecordUpdated.new.useInAppForSlotBooking);
				setSdrPaymentMode(handleRecordUpdated.new.useInAppForSdrPayment);
			})
			.subscribe((status) => { });

		// return () => {
		// 	if (insertUnitListener) {
		// 		supabase.removeSubscription(insertUnitListener);
		// 		insertUnitListener = null;
		// 	}
		// 	if (updateUnitListener) {
		// 		supabase.removeSubscription(updateUnitListener);
		// 		updateUnitListener = null;
		// 	}
		// 	if (insertAllotmentListener) {
		// 		supabase.removeSubscription(insertAllotmentListener);
		// 		insertAllotmentListener = null;
		// 	}
		// 	if (updateAllotmentListener) {
		// 		supabase.removeSubscription(updateAllotmentListener);
		// 		updateAllotmentListener = null;
		// 	}
		// 	if (updateEventListener) {
		// 		supabase.removeAllSubscriptions(updateEventListener);
		// 		updateEventListener = null;
		// 	}
		// };
	}, [activeMenu]);

	useEffect(() => {
		if (allAllotments.current.length > 0) {
			let allotmentPaymentIds = [];
			allAllotments.current.forEach((allotment) => {
				allotmentPaymentIds.push(allotment?.allotmentPaymentId);
			});
			let insertCRMListener = supabase
				.from(`CRM`)
				.on("INSERT", (handleRecordUpdated) => {
					if (allotmentPaymentIds.includes(handleRecordUpdated.new.allotmentPaymentId)) {
						getAllotments();
						setRecordUpdated({
							type: "allotmentCRM",
							data: handleRecordUpdated,
						});
					}
				})
				.subscribe((status) => {
					console.log("status: ", status);
				});
			let updateCRMListener = supabase
				.from(`CRM:allotmentPaymentId=in.(${allotmentPaymentIds})`)
				.on("UPDATE", (handleRecordUpdated) => {
					const newDataIndex = allAllotments.current.findIndex((e) => e.allotmentPaymentId === handleRecordUpdated.new.allotmentPaymentId);
					if (newDataIndex !== -1) {
						allotmentFlag.current = false;
						//Cheking data is found or not+
						let newData = [...allAllotments.current];
						newData[newDataIndex]["CRM"] = [handleRecordUpdated.new]; //@todo
						// newData[newDataIndex]["totalUnitPrice"] = handleRecordUpdated.new.newUnitCost && handleRecordUpdated.new.newUnitCost.total;
						allAllotments.current = newData;
						allotmentFlag.current = true;
						setRecordUpdated({ type: "allotment", data: handleRecordUpdated }); // set State to trigger the useffect for stepper functionality
					} else {
						getAllotments();
						setRecordUpdated({ type: "allotment", data: handleRecordUpdated });
					}
				})
				.subscribe((status) => { });
			// return () => {
			// 	if (insertCRMListener) {
			// 		supabase.removeSubscription(insertCRMListener);
			// 		insertCRMListener = null;
			// 	}
			// 	if (updateCRMListener) {
			// 		supabase.removeSubscription(updateCRMListener);
			// 		updateCRMListener = null;
			// 	}
			// };
		}
	}, [activeMenu, allAllotments.current]);

	// useEffect(() => {
	// 	if (ppTokenIds.length > 0) {
	// 		// ! add snapshot for priority pass dates
	// 		// ? subscribed for all events hence commented
	// 		let addEventTokenListener = supabase
	// 			.from(`EventTokens`)
	// 			.on("INSERT", (handleRecordUpdated) => {
	// 				console.log(handleRecordUpdated);
	// 				if (ppTokenIds.includes(handleRecordUpdated.new.prerequisiteId)) {
	// 					getTokens();
	// 				}
	// 			})
	// 			.subscribe((status) => {
	// 				console.log("status: ", status);
	// 			});
	// 		let updateEventTokenListener = supabase
	// 			.from(`EventTokens:prerequisiteId=in.(${ppTokenIds})`)
	// 			.on("UPDATE", (handleRecordUpdated) => {
	// 				console.log(handleRecordUpdated);
	// 				getTokens();
	// 			})
	// 			.subscribe((status) => {
	// 				console.log("status: ", status);
	// 			});
	// 		return () => {
	// 			if (addEventTokenListener) {
	// 				supabase.removeSubscription(addEventTokenListener);
	// 				addEventTokenListener = null;
	// 			}
	// 			if (updateEventTokenListener) {
	// 				supabase.removeSubscription(updateEventTokenListener);
	// 				updateEventTokenListener = null;
	// 			}
	// 		};
	// 	}
	// }, [ppTokenIds]);

	const handleNext = (data, i) => {
		presentLoader();
		let newData = [...allData];
		newData[i]["activeStep"] = data.activeStep + 1;
		setAllData(newData);
		dismissLoader();
	};

	const handleBack = (data, i) => {
		presentLoader();
		let newData = [...allData];
		newData[i]["activeStep"] = data.activeStep - 1;
		setAllData(newData);
		dismissLoader();
	};

	function getSectionComponent(data) {
		switch (data.activeStep) {
			case 0:
				return <Token token={data.token} allotment={data.allotment} serverTime={serverTime} updatedRecord={updatedRecord} handleUpdateRecord={allData} />;
			case 1:
				return data.allotment ? <Allotment allotment={data?.allotment} handleNext={getAllotments} serverTime={serverTime} /> : null;
			// <div>Allotment Data</div>
			case 2:
				return <BalanceSDR allotment={data.allotment} SdrPaymentMode={SdrPaymentMode} />;
			case 3:
				return <BalanceOCRGST allotment={data.allotment} />;
			case 4:
				return <Agreement allotment={data.allotment} slotBookMode={slotBookMode} />;
			default:
				return null;
		}
	}
	function getStepperWiseData(obj, type) {
		let step;
		let totalSDR = obj?.allotmentData?.unitCost?.sdr;
		let paidSDR = obj?.allotmentData?.paidAmt?.sdr;
		if (obj.allotmentData?.CRM[0]?.sentForAgreement || obj.allotmentData?.CRM[0]?.skipCreateDraft) {
			step = StepperENUM.AGREEMENT;
		} else if (totalSDR - paidSDR <= 0 && obj.allotmentData.isAgreementFormFilled) {
			step = StepperENUM.BALANCE_OCR_GST;
		} else if (type === "token" && activeMenu !== "allotments") {
			if (
				obj.allotmentData?.pricingType !== "preselect" &&
				(obj.allotmentData?.status === "Payment Complete" || obj.allotmentData?.status === "Agreement Done") &&
				obj.allotmentData?.kycFormFilled
			) {
				step = StepperENUM.BALANCE_SDR;
			} else if (
				obj.allotmentData?.pricingType === "preselect" &&
				obj.allotmentData?.preselectConfirmation === "confirmed" &&
				(obj.allotmentData?.status === "Payment Complete" || obj.allotmentData?.status === "Agreement Done") &&
				obj.allotmentData?.kycFormFilled
			) {
				step = StepperENUM.BALANCE_SDR;
			} else if (obj.allotmentData) {
				if (obj.allotmentData.pricingType === "preselect") {
					obj.token.paidAmount >= obj.token.amount && obj.allotmentData?.preselectConfirmation === "confirmed" ? (step = 1) : (step = 0);
				} else {
					step = StepperENUM.ALLOTMENT;
				}
			} else {
				step = StepperENUM.TOKEN;
			}
		} else {
			if (
				(obj.allotmentData?.status === "Payment Complete" || obj.allotmentData.status === "Agreement Done") &&
				obj.allotmentData.kycFormFilled
			) {
				step = StepperENUM.BALANCE_SDR;
			} else {
				step = StepperENUM.ALLOTMENT;
			}
		}
		return {
			token: type === "token" ? obj.token : null,
			allotment: obj.allotmentData,
			steps:
				type === "token" && activeMenu !== "allotments"
					? [
						{
							label: "Token",
							title: "List of all the tokens purchased for the events ",
						},
						{ label: "Allotment", title: "List of all the units" },
						{ label: "Balance SDR", title: "Balance SDR" },
						{ label: "Balance OCR & GST", title: "Balance OCR & GST" },
						{ label: "Agreement", title: "Agreement" },
					]
					: [
						{ label: "Allotment", title: "List of all the units" },
						{ label: "Balance SDR", title: "Balance SDR" },
						{ label: "Balance OCR & GST", title: "Balance OCR & GST" },
						{ label: "Agreement", title: "Agreement" },
					],
			activeStep: step,
			directAllotment: type === "token" ? false : true,
			mainActiveStep: step,
		};
	}

	function mergeAndSortByDate(arr1, arr2) {
		let mergedArray = arr1.concat(arr2);
		mergedArray.sort((a, b) => {
			return new Date(a.created_at) - new Date(b.created_at);
		});
		return mergedArray;
	}

	//Stepper Functionality
	useEffect(() => {
		if (tokenFlag.current && allotmentFlag.current && activeMenu === "dashboard") {
			presentLoader();
			// const data = [];
			// allTokens?.current?.map((token, i) => {
			// 	const allotmentData = allAllotments.current?.find((allotment) => allotment?.paymentId?.paymentId === token.paymentId);
			// 	let obj = { token, allotmentData };
			// 	let filterData = getStepperWiseData(obj, "token");
			// 	data.push(filterData);
			// });
			// allAllotments.current.map((allotment, i) => {
			// 	if (allotment?.paymentId === null) {
			// 		let obj = { token: null, allotmentData: allotment };
			// 		let filterData = getStepperWiseData(obj, "allotment");
			// 		data.push(filterData);
			// 	}
			// });
			// console.log("final data", data);
			let arry = mergeAndSortByDate(
				allTokens?.current,
				allAllotments.current.filter((allotment) => allotment?.paymentId === null)
			);
			let finalData = [];
			arry.map((obj, i) => {
				if ("tokenNumber" in obj) {
					const allotmentData = allAllotments.current?.find((allotment) => allotment?.paymentId?.paymentId === obj.paymentId);
					let filterData = getStepperWiseData({ token: obj, allotmentData }, "token");
					finalData.push(filterData);
				} else {
					let filterData = getStepperWiseData({ token: null, allotmentData: obj }, "allotment");
					finalData.push(filterData);
				}
			});
			setAllData(finalData.reverse());
			// allData.current = data;
			dismissLoader();
		} else {
			presentLoader();
			const data = [];
			allAllotments.current.map((allotment, i) => {
				if (
					allotment.pricingType !== "preselect" ||
					(allotment.pricingType === "preselect" && allotment.preselectConfirmation === "confirmed")
				) {
					let obj = { token: null, allotmentData: allotment };
					let filterData = getStepperWiseData(obj, "allotment");
					data.push(filterData);
				}
			});
			setAllData(data);
			dismissLoader();
		}
	}, [tokenFlag.current, allotmentFlag.current, recordUpdated, activeMenu]);

	async function getTokens() {
		return new Promise(async (resolve, reject) => {
			tokenFlag.current = false;
			presentLoader();
			await getTokenServerTime()
				.then(async (res) => {
					let time = res?.data?.currentTime;
					setServerTime(res?.data?.currentTime);
					await getLeadTokens(loggedInUser.leadId)
						.then(async (resp) => {
							// ? get prerequisite tokens from resp
							// ? link it with upgraded token
							const prerequisiteTokens = resp.data.filter((data) => {
								if (data.isPrerequisiteUsed) return data;
							});
							let allTokensReq = resp.data.filter((data) => {
								if (!data.isPrerequisiteUsed) return data;
							});
							// ! get tokens whose pre-requisite tokens are bought by lead
							// and get Preselect token project details
							const tokenIds = [];
							allTokensReq.forEach(async (token) => {
								token.isPrerequisiteAvailable = false;
								token.prerequisiteMsg = "";
								token.upgradableTokens = [];
								token.timer = null;
								token.showPPBtn = false;
								token.closeTimer = null;
								tokenIds.push(token.eventTokenId.eventTokenId);
								setPPTokenIds(tokenIds);
								token.upgradedFrom =
									prerequisiteTokens.find((tk) => {
										if (token.paymentId === tk.linkedTokenId.paymentId) {
											return tk;
										}
									}) ?? null;

								if (token.eventTokenId.tokenId.isPreselect) {
									await getPreselectTokenData(token.paymentId)
										.then(async (projectDetailsRes) => {
											let obj = projectDetailsRes[0];

											let unitType = obj?.unitId?.projectId?.customerDisplayInventoryType
												? obj?.unitId?.projectId?.customerDisplayInventoryType?.length === 2
													? `${obj?.unitId?.inventoryTypeId?.type} (${obj?.unitId?.displayUnitType})`
													: obj?.unitId?.projectId?.customerDisplayInventoryType?.includes("Inventory Type")
														? obj?.unitId?.inventoryTypeId?.type
														: obj?.unitId?.displayUnitType
												: `${obj?.unitId?.inventoryTypeId?.type} (${obj?.unitId?.displayUnitType})`;
											token.allotmentPaymentId = obj;
											token.kycFormFilled = obj?.kycFormFilled;
											if (obj?.unitId) {
												token.projectDetails = `${obj?.unitId?.projectId?.projectName} | ${obj?.unitId?.wingId?.wingName} | ${obj?.unitId?.floorNo} | ${obj?.unitId?.unitNo} | ${unitType}`;
											} else {
												token.projectDetails = `${obj?.inventoryMergedId?.unit1Id?.projectId?.projectName} | ${obj?.inventoryMergedId?.unit1Id?.wingId?.wingName} | ${obj?.inventoryMergedId?.unit1Id?.floorNo} - ${obj?.inventoryMergedId?.unit2Id?.floorNo} | ${obj?.inventoryMergedId?.unit1Id?.unitNo} - ${obj?.inventoryMergedId?.unit2Id?.unitNo} | Merged Unit`;
											}
										})
										.catch((err) => {
											console.error(err);
											tokenFlag.current = true;
											setRecordUpdated({ type: "token", data: {} });
											dismissLoader();
											reject(false);
											//show error toast
										});
								}
							});
							await getPriorityPassTokens(tokenIds)
								.then(async (prereqResp) => {
									// ! if new token is available; show 'Priority Pass Available' button
									prereqResp.data.forEach((ppToken) => {
										allTokensReq = allTokensReq.map((token, index) => {
											if (token.eventTokenId.eventTokenId === ppToken.prerequisiteId) {
												token.isPrerequisiteAvailable = false;
												token.startPaymentFrom = ppToken.startPaymentFrom;
												// ? when priority pass is available
												if (ppToken.startPaymentFrom <= time && time < ppToken.expirePaymentOn) {
													token.prerequisiteMsg =
														"Priority Pass available. Complete payment before " +
														new Date(ppToken.expirePaymentOn).toLocaleString() +
														" to avail Priority Pass!";
													// ? check if prerequisite token amount is paid
													if (token.paidAmount >= token.amount) {
														token.isPrerequisiteAvailable = true;
														token.prerequisiteMsg = "";
														token.showPPBtn = true;
														token.upgradableTokens.push(ppToken);
														token.closeTimer = ppToken.expirePaymentOn;
													}
												}
												// ? if priority pass payment has not started
												if (ppToken.startPaymentFrom > time) {
													token.prerequisiteMsg =
														"Priority Pass will be available from " +
														new Date(ppToken.startPaymentFrom).toLocaleString() +
														" . Complete payment before " +
														new Date(ppToken.expirePaymentOn).toLocaleString() +
														" to avail Priority Pass!";
													// ? check if prerequisite token amount is paid
													if (token.paidAmount >= token.amount) {
														token.isPrerequisiteAvailable = true;
														if (ppToken.startTimerFrom > time) {
															setTimeout(() => {
																token.timer = ppToken.startPaymentFrom;
																token.closeTimer = ppToken.expirePaymentOn;
																// setAllTokens((pre) => {
																// 	pre[index].timer = ppToken.startPaymentFrom;
																// 	pre[index].showPPBtn = true;
																// });

																token.timer = ppToken.startPaymentFrom;
																token.showPPBtn = true;
															}, ppToken.startTimerFrom - time);
														} else {
															token.timer = ppToken.startPaymentFrom;
															token.closeTimer = ppToken.expirePaymentOn;
														}
														token.prerequisiteMsg =
															"Priority Pass will be available from " +
															new Date(ppToken.startPaymentFrom).toLocaleString() +
															"!";
														token.upgradableTokens.push(ppToken);
													}
												}
											}
											return token;
										});
									});
									allTokensReq = allTokensReq.map((token) => {
										if (token.eventTokenId.tokenId.isPreselect) {
											const tokenBuyDate = new Date(token.created_at);
											tokenBuyDate.setTime(tokenBuyDate.getTime() + process.env.REACT_APP_TOKEN_EXPIRY_TIME * 60000);
											token.validity = `${new Date(tokenBuyDate).toDateString()}, ${new Date(tokenBuyDate).toLocaleTimeString(
												[],
												{
													hour: "2-digit",
													minute: "2-digit",
												}
											)}`;
										} else {
											const tokenBuyDate = new Date(token.created_at);
											tokenBuyDate.setDate(tokenBuyDate.getDate() + token.eventTokenId.tokenId.validity);
											token.validity = `${new Date(tokenBuyDate).toDateString()}, ${new Date(tokenBuyDate).toLocaleTimeString(
												[],
												{
													hour: "2-digit",
													minute: "2-digit",
												}
											)}`;
										}

										if (token.paidAmount < token.amount) {
											if (token.eventTokenId.tokenId.isPreselect) {
												token.expiry = token.created_at + process.env.REACT_APP_TOKEN_EXPIRY_TIME * 60000;
											} else if (token.eventTokenId.tokenId.isPriorityPass) {
												// ! vedashree changes for timer
												token.expiry = token.eventTokenId.expirePaymentOn;
											} else {
												// ? remove TokenTransactions[0] because it gives NaN when this function is called through snapshot
												token.expiry = token.created_at + process.env.REACT_APP_TOKEN_EXPIRY_TIME * 60000;
											}
										}
										return token;
									});
									allTokens.current = allTokensReq;
									tokenFlag.current = true;
									setRecordUpdated({ type: "token", data: {} });
									dismissLoader();
									resolve(true);
								})
								.catch((err) => {
									console.log("err: ", err);
									//show error
									dismissLoader();
									tokenFlag.current = true;
									setRecordUpdated({ type: "token", data: {} });
									reject(false);
								});
						})
						.catch((err) => {
							console.log("err: ", err);
							errorTost("Could not get tokens!");
							dismissLoader();
							tokenFlag.current = true;
							setRecordUpdated({ type: "token", data: {} });
							reject(false);
						});
				})
				.catch((err) => {
					console.log("err: ", err);
					errorTost("Could not get tokens!");
					dismissLoader();
					tokenFlag.current = true;
					setRecordUpdated({ type: "token", data: {} });
					reject(false);
				})
				.catch((err) => {
					console.log("err: ", err);
					errorTost("Could not get tokens!");
					dismissLoader();
					tokenFlag.current = true;
					setRecordUpdated({ type: "token", data: {} });
					reject(false);
				});
		});
	}

	async function getAllotments() {
		allotmentFlag.current = false;
		presentLoader();
		await getLeadAllotmentsForDashboard(loggedInUser.leadId)
			.then(async (resp) => {
				allAllotments.current = resp.data;
				let _arr = resp.data;
				for (let [index, _allotment] of _arr.entries()) {
					_allotment.totalUnitPrice = _allotment?.unitCost?.total;
					let menuOpt = ["View Details"];
					if (_allotment.status === "Payment Complete" || _allotment.status === "Partial Payment Done") {
						if (_allotment.CancelUnitRequests.length > 0) {
							let Cancelled_Far_vision = _allotment.CancelUnitRequests.find((ele) => {
								return ele.cancelledInFarvision === true;
							});
							if (!Cancelled_Far_vision) {
								menuOpt.push("Cancel Unit");
							}
						} else {
							menuOpt.push("Cancel Unit");
						}
					}
					if (_allotment?.launchId) {
						await getPreselectConfirmationsConfig(
							_allotment?.paymentId?.eventId,
							_allotment?.paymentId?.eventTokenId?.eventTokenId,
							_allotment?.launchId
						)
							.then((val) => {
								_allotment.discountPercentage = val?.data?.length > 0 ? val?.data[0]?.priceDiscount : 0;
								_allotment.showCost = val?.data?.length > 0 ? val?.data[0]?.showPreselectPrices : [];
								_allotment.paymentId.eventTokenId.eventId.preselectConfirmationConfig =
									val?.data?.length > 0
										? val?.data[0]?.preselectConfirmationConfig
										: _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig;
								if (
									_allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime - Date.now() <=
									parseInt(_allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.timer) * 60000
								) {
									_allotment.expiry = _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime;
									getServerTime();
								}
								if (
									val?.data?.length > 0
										? val?.data[0]?.preselectConfirmationConfig?.startDateTime
										: _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime >
										new Date().getTime()
								) {
									setTimeout(() => {
										allAllotments.current[index].closeTimer =
											val?.data?.length > 0
												? val?.data[0]?.preselectConfirmationConfig?.endDateTime
												: _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime;
										allAllotments.current[index].timer =
											val?.data?.length > 0
												? val?.data[0]?.preselectConfirmationConfig?.startDateTime
												: _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime;
									}, _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime - new Date().getTime());
								} else {
									_allotment.timer =
										val?.data?.length > 0
											? val?.data[0]?.preselectConfirmationConfig?.startDateTime
											: _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime;
									_allotment.closeTimer =
										val?.data?.length > 0
											? val?.data[0]?.preselectConfirmationConfig?.endDateTime
											: _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime;
								}
							})
							.catch((err) => {
								dismissLoader();
								errorTost("Could not get allotments!");
							});
					} else {
						_allotment.discountPercentage = 0;
						_allotment.showCost = [];
						if (
							_allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime - Date.now() <=
							parseInt(_allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.timer) * 60000
						) {
							_allotment.expiry = _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime;
						}
						if (_allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime > new Date().getTime()) {
							setTimeout(() => {
								allAllotments.current[index].closeTimer =
									_allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime;
								allAllotments.current[index].timer =
									_allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime;
							}, _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime - new Date().getTime());
						} else {
							_allotment.timer = _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig
								? _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.startDateTime
								: null;
							_allotment.closeTimer = _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig
								? _allotment.paymentId?.eventTokenId?.eventId?.preselectConfirmationConfig?.endDateTime
								: null;
						}
					}
					_allotment = { ..._allotment, menuOpt: menuOpt };
					_arr[index] = _allotment;
				}
				// })

				// allAllotments.current = resp.data;

				allAllotments.current = _arr;
				allotmentFlag.current = true;
				setRecordUpdated({ type: "allotment", data: {} });
				dismissLoader();
			})
			.catch((err) => {
				console.log("err: ", err);
				allotmentFlag.current = true;
				errorTost("Could not get allotments!");
				setRecordUpdated({ type: "allotment", data: {} });
				dismissLoader();
			});
		sdrPaymentMode()
			.then((resp) => {
				if (resp.data[0].useInAppForSdrPayment) {
					setSdrPaymentMode(true);
				} else {
					setSdrPaymentMode(false);
				}
				if (resp.data[0].useInAppForSlotBooking) {
					setSlotBooktMode(true);
				}
			})
			.catch((err) => {
				console.error("Setting-Table-err", err);
			});
	}

	// const handleTokenNext = () => {
	// 	getTokens();
	// };
	// const handleAllotmentNext = () => {
	// 	getAllotments();
	// };

	const handleMobileStepper = (activeStep, idx, length) => {
		if (activeStep === StepperENUM.TOKEN && (idx === activeStep || idx === activeStep + 1 || idx === activeStep + 2)) {
			return true;
		} else if (activeStep === StepperENUM.ALLOTMENT) {
			if (length === 5 && (idx === activeStep || idx === activeStep - 1 || idx === activeStep + 1)) {
				return true;
			} else if (length === 4 && (idx === activeStep || idx === activeStep - 1 || idx === activeStep + 1)) {
				return true;
			} else {
				return false;
			}
		} else if (activeStep === StepperENUM.BALANCE_SDR || activeStep === StepperENUM.BALANCE_OCR_GST) {
			if (length === 5 && (idx === activeStep || idx === activeStep - 1 || idx === activeStep + 1)) {
				return true;
			} else if (length === 4 && (idx === activeStep || idx === activeStep - 1 || idx === activeStep - 2)) {
				return true;
			} else {
				return false;
			}
		} else if (activeStep === StepperENUM.AGREEMENT) {
			if (length === 5 && (idx === activeStep || idx === activeStep - 1 || idx === activeStep - 2)) {
				return true;
			} else if (length === 4 && (idx === activeStep - 3 || idx === activeStep - 1 || idx === activeStep - 2)) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	};

	const handleChange = (event) => {
		const status = event;
		setSort(status);
		if (status === "All") {
			setFilterAllotments(allData);
		} else {
			const selectedItem = allData.filter((item) => item?.allotment?.status === status);
			setFilterAllotments(selectedItem);
		}
	};

	return (
		<div className={cssClasses.mainWrapper}>
			{`/Home/${activeMenu.charAt(0).toUpperCase() + activeMenu.slice(1)}` === path.pathname && activeMenu === "allotments" && (
				<div className={cssClasses.headerMainContent}>
					<div className={cssClasses.wrapperHeader}>
						<div className={cssClasses.wrapperTitleUserName}>
							<div className={cssClasses.headerTitle}>{filterAllotments.length} Allotments</div>
						</div>
					</div>
					{activeMenu === "allotments" && allData.length > 0 && (
						<div className={cssClasses.searchData}>
							<div className={cssClasses.dropdownWrapper}>
								<DropDown
									onChangeSelect={(e) => {
										handleChange(e);
									}}
									selectedValue={sort}
									style={{
										selectedColor: "#657084",
										background: "#F2F4F7",
									}}
									list={menuItem}
								/>
							</div>
						</div>
					)}
				</div>
			)}
			<div className={cssClasses.section}>
				<div className={cssClasses.tokenWrapCards}>
					{filterAllotments && filterAllotments.length > 0 && (
						<Card
							style={{
								borderRadius: showSalesManagerCard ? "0" : 16,
								boxShadow: "none",
								height: "100%",
								overflow: "auto",
								padding: showSalesManagerCard ? "0" : "1.2rem",
							}}
						>
							{activeMenu === "dashboard" && (
								<div className={cssClasses.mainCardHeader}>
									<div className={cssClasses.buyText}>Buy Apartment's</div>
									<div className={cssClasses.headerSubTitle}>
										Your CUID is &nbsp;
										<span className={cssClasses.subTitleVjID}>
											#VJ
											{loggedInUser?.leadDisplayId.slice(0, -4) + "-" + loggedInUser?.leadDisplayId.slice(-4)}
										</span>
									</div>
								</div>
							)}
							<div>
								{filterAllotments.map((data, i) => (
									<Card
										sx={{
											overflow: "auto",
											boxShadow: "none",
											borderRadius: "12px",
										}}
										className={cssClasses.cardMain}
										key={i}
									>
										<CardContent sx={{ padding: showSalesManagerCard ? "0" : "1.6rem" }}>
											<Box sx={{ width: "100%" }}>
												<Stepper
													sx={{ overflow: "auto" }}
													alternativeLabel
													activeStep={data.directAllotment ? data.activeStep - 1 : data.activeStep}
													// activeStep={data.activeStep -1}
													connector={<QontoConnector />}
												>
													{!showSalesManagerCard &&
														data.steps.map((text, idx) => (
															<Step key={idx}>
																<StepLabel className={classes.label} StepIconComponent={QontoStepIcon}>
																	<span className="stepperTitle">{text.label}</span>
																	<img
																		data-tooltip-id={`${i}+${idx}`}
																		src={InfoIcon}
																		aria-label={`${i}+${idx}`}
																		alt="info"
																		style={{
																			verticalAlign: "middle",
																			marginLeft: 4,
																		}}
																	/>
																	<ReactTooltip
																		style={{
																			zIndex: "10",
																			fontFamily: "Inter-Regular",
																			fontSize: "1.8rem",
																			// overflow: "auto",
																		}}
																		content={text.title}
																		id={`${i}+${idx}`}
																		place="right"
																	/>
																</StepLabel>
															</Step>
														))}
													{showSalesManagerCard &&
														data.steps.map((text, idx) => {
															return (
																handleMobileStepper(data.activeStep, idx, data.steps.length) && (
																	<Step
																		key={idx}
																		active={
																			data.directAllotment ? idx <= data.activeStep - 1 : idx <= data.activeStep
																		}
																		completed={
																			data.directAllotment
																				? data.activeStep === data.mainActiveStep &&
																				idx === data.mainActiveStep - 1
																				: data.activeStep === data.mainActiveStep &&
																				idx === data.mainActiveStep
																		}
																		data={data}
																	>
																		<StepLabel className={classes.label} StepIconComponent={QontoStepIcon}>
																			<span className="stepperTitle">{text.label}</span>
																			<img
																				data-tooltip-id={`${i}+${idx}`}
																				src={InfoIcon}
																				aria-label={`${i}+${idx}`}
																				alt="info"
																				style={{
																					verticalAlign: "middle",
																					marginLeft: 4,
																				}}
																			/>
																			<ReactTooltip
																				style={{
																					fontFamily: "Inter-Regular",
																					fontSize: "1.2rem",
																					// overflow: "auto",
																					zIndex: "1000",
																				}}
																				content={text.title}
																				id={`${i}+${idx}`}
																				place="bottom"
																			/>
																		</StepLabel>
																	</Step>
																)
															);
														})}
												</Stepper>
												<Box
													sx={{
														padding: { xs: "0.4rem", md: "2rem", sm: "1.2rem" },
													}}
												>
													{getSectionComponent(data)}
													<div className={cssClasses.btnContent}>
														<Button
															disabled={
																(data.activeStep === 0 && !data.directAllotment) ||
																(data.activeStep === 1 && data.directAllotment)
															}
															className={
																(data.activeStep === 0 && !data.directAllotment) ||
																	(data.activeStep === 1 && data.directAllotment)
																	? cssClasses.nextBtn
																	: cssClasses.nextBtnEnable
															}
															onClick={() => handleBack(data, i)}
															startIcon={
																<img src={ArrowRightIcon} alt="left" style={{ transform: "rotate(-0.50turn)" }} />
															}
														>
															Back
														</Button>
														{data.activeStep !== data.steps.length && (
															<Button
																disabled={data.activeStep === data.mainActiveStep}
																className={
																	data.activeStep === data.mainActiveStep
																		? cssClasses.nextBtn
																		: cssClasses.nextBtnEnable
																}
																onClick={() => {
																	handleNext(data, i);
																}}
																endIcon={<img src={ArrowRightIcon} alt="right" />}
															>
																Next
															</Button>
														)}
													</div>
												</Box>
											</Box>
										</CardContent>
									</Card>
								))}
							</div>
						</Card>
					)}
					{allData.length === 0 && activeMenu === "dashboard" && (
						<div className={cssClasses.noDataWrapper}>
							<div className={cssClasses.noDataMsg}>
								<div className={cssClasses.emptyIcon}>
									<img src={EmptyDashboardIcon} alt="No Tokens" />
								</div>
								<div className={cssClasses.emptyTitle}>No tokens found</div>
								<div>No tokens created. To continue this get the token first.</div>
							</div>
						</div>
					)}
					{filterAllotments.length === 0 && activeMenu === "allotments" && (
  sessionStorage.getItem("fromAllotmentConfirm") ? (
    // ✅ Show loader while allotments are being fetched after confirmation
    <div className={cssClasses.noDataWrapper}>
      <div className={cssClasses.noDataMsg}>
        <CircularProgress size={60} color="primary" />
     
      </div>
    </div>
  ) : (
    // ⛔ Default empty state
    <div className={cssClasses.noDataWrapper}>
      <div className={cssClasses.noDataMsg}>
        <div className={cssClasses.emptyIcon}>
          <img src={EmptyListIcon} alt="No Allotments" />
        </div>
        <div className={cssClasses.emptyTitle}>No Allotments to show!</div>
      </div>
    </div>
  )
)}

				</div>
			</div>
		</div>
	);
};

export default Home;

export const SalesManagerCard = ({ style = {} }) => {
	const showSalesManagerCard = useMediaQuery("(max-width:820px)");
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	return !showSalesManagerCard ? (
		<Card className={cssClasses.salesDetails} style={{ boxShadow: "none", borderRadius: "16px", ...style }}>
			<div>Your Sales Details</div>
			<CardContent className={cssClasses.salesCardContent}>
				<div className={cssClasses.salesContentFirstData}>
					<img className={cssClasses.profileImg} src={UserIcon} alt="mail" />
					<div>
						<div className={cssClasses.salesManagerData}>Sales Manager name</div>
						<div className={cssClasses.SalesManagerText}>{loggedInUser.userId?.name ? loggedInUser.userId?.name : "NA"}</div>
					</div>
				</div>
				<div className={cssClasses.salesContentDetails}>
					<img className={cssClasses.profileImg} src={MailIcon} alt="mail" />{" "}
					<span style={{ wordBreak: "break-all" }}>{loggedInUser.userId?.email ?? <span style={{ fontWeight: "bold" }}>NA</span>}</span>
				</div>
				<div className={cssClasses.salesContentDetails}>
                    <img className={cssClasses.profileImg} src={PhoneCallIcon} alt="call" />
                    {loggedInUser.userId?.assignedCallerDid ? (
                        `${loggedInUser.userId?.assignedCallerDid}`
                    ) : (
                        <span style={{ fontWeight: "bold" }}>NA</span>
                    )}
                </div>
			</CardContent>
		</Card>
	) : null;
};
